<div class="row">
  <div class="col-12 nopadding" *ngIf="menuVerti">
    <app-sidebar></app-sidebar>
    <div class="main-panel">
      <div class="main-content">
        <div class="container-fluid">
          <router-outlet (activate)="onActivate($event)"></router-outlet>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 nopadding" *ngIf="!menuVerti">
    <app-navbar></app-navbar>
    <div class="parallax"></div>
    <div class="main-panel" style="width:100%;">
      <div class="main-content">
        <div class="container-fluid">
          <router-outlet (activate)="onActivate($event)"></router-outlet>
        </div>
      </div>
      <app-footer></app-footer>
    </div>
  </div>
</div>
